import { createFileRoute, redirect } from '@tanstack/react-router'
import type { User } from '@supabase/supabase-js'
import { Profile, profile } from '@/lib/queries/profiles'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'
import { nextOnboardingStep } from '@/features/onboarding/steps'

interface AuthenticatedRouteContext {
  currentUser: User
  currentProfile: Profile
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    // Guard: ensure user is authenticated and profile is loaded
    if (!context.auth.isAuthenticated || !context.auth.user) {
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.pathname,
        },
      })
    }

    // Ensure profile is loaded before rendering route
    // This shows router's defaultPendingComponent during load
    const profileData = await context.queryClient.query({
      ...profile.findOne(context.auth.user.id),
      staleTime: 'static',
    })

    if (nextOnboardingStep(profileData)) {
      throw redirect({ to: '/onboarding', search: { redirect: location.href } })
    }

    // Return non-null references for child routes
    return {
      currentUser: context.auth.user,
      currentProfile: profileData,
    } as AuthenticatedRouteContext
  },
  component: AuthenticatedLayout,
})
